<script setup lang="ts">
const {fetch: fetchProjectsMeta} = useProjectsMeta()
const projects = useProjects()
const {
  public: {baseUrl},
} = useRuntimeConfig()

const [{data: initialMeta}, {pending, data: initialList}] = await Promise.all([
  useAsyncData('project-meta', () => fetchProjectsMeta()),
  useAsyncData('project-industry', () => projects.fetch()),
])

const {data: meta} = useLivePreview({initialData: initialMeta.value, depth: 1})
const {data: list} = useLivePreview({initialData: initialList.value, depth: 2})

const dataList = ref(list.value)

if (!list) {
  throw showError({
    statusCode: 404,
  })
}

const seo = meta.value?.meta

useSeoMeta({
  title: seo?.title ? `${seo.title} | Webamboos` : 'Projects | Webamboos',
  description: seo?.description,
  ogUrl: `${baseUrl}/projects`,
  ogTitle: seo?.ogTitle || seo?.title,
  ogDescription: seo?.ogDescription || seo?.description,
  ogImage: resolveMediaUrl(seo?.image),
  ogImageAlt: resolveMediaAlt(seo?.image),
})
</script>

<template>
  <Loader :pending="pending">
    <Container class="screen-content flex-1 px-0 pb-32">
      <LayoutPageHeader :title="dataList!.industry ? dataList!.industry.name : $t('home.projects.title')" />
      <section v-if="dataList" class="mt-8 flex flex-col gap-y-4 md:gap-y-20">
        <ProjectPreview
          v-for="(project, index) of dataList.projects"
          :key="project.slug"
          :project="project"
          :industry="dataList.industry"
          :is-mirrored="index % 2 !== 0"
        />
      </section>
    </Container>
  </Loader>
</template>
